import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GazetteService } from '../data/gazette.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { DatePipe } from '@angular/common';
import { AuthWebService } from 'app/services/authweb.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-view-edit-gazettes',
  templateUrl: './view-edit-gazettes.component.html',
  styleUrls: ['./view-edit-gazettes.component.scss']
})
export class ViewEditGazettesComponent implements OnInit {
  event_id = 0;
  apps: any = [];
  status: any = "";
  isLoading = false;
  date_scheduled: any;
  date_sent: any;
  note = "";
  isEdit = false;
  quillConfig = {
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //[ 'header'],


        ['clean'],                                         // remove formatting button

        ['link'],
        ['link', 'image', 'video']
      ],

    }

  }
  scheduled: any;
  sent: any;
  selectedStatus:any;
  isAdvert: boolean = false;
  constructor(private router: Router, private activeRoute: ActivatedRoute, private service: GazetteService, private toastService: ToastNotificationService, public authentication: AuthWebService, private confirmDialogService: ConfirmDialogService,) { }
  Form = new FormGroup({
    description: new FormControl(''),
    email: new FormControl(''), 
    attachmentName: new FormControl(''), 
  });
  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: Params) => {
      this.event_id = params['id'];
      this.getApps(this.event_id);
      this.checkAdvert()
    });
  }
  send(){
    this.isLoading = true;
    this.Form.value.attachmentName = 'Gazette - '+this.event_id;
    this.service.sendGazette(this.Form.value).subscribe(x => {
      if(x == true){
        this.isLoading = false;
        document.getElementById('closesendEmailGaz').click();
        this.toastService.success('Sent Mail','Advert');
      }
    })
  }
  selectApplication() {
    this.router.navigateByUrl('/select/gazettes/' + this.event_id)
  }
  getApps(id) {
    this.isLoading = true;
    this.service.getSelected(id).subscribe((x: any) => {
      console.log(x)
      if (x.length > 0) {
        if (x[0].regulatory_event.reg_event_status == 1) {
          this.status = "Saved"

        }
        if (x[0].regulatory_event.reg_event_status == 11) {
          this.status = "Ready for Approval"

        }
        if (x[0].regulatory_event.reg_event_status == 13) {
          this.status = "Returned for editing"

        }
        if (x[0].regulatory_event.reg_event_status == 15) {
          this.status = "Submitted for Approved"

        }
        if (x[0].regulatory_event.reg_event_status == 21) {
          this.status = "Approved"

        }
        if (x[0].regulatory_event.reg_event_status == 23) {
          this.status = "Submitted for Quote"

        }
        if (x[0].regulatory_event.reg_event_status == 31) {
          this.status = "Quote Accepted"

        }
        this.selectedStatus = x[0].regulatory_event.reg_event_status;
        this.date_scheduled = new DatePipe('en-US').transform(x[0].regulatory_event.date_scheduled, 'yyyy-MM-dd');
        this.date_sent = new DatePipe('en-US').transform(x[0].regulatory_event.date_sent, 'yyyy-MM-dd');
        for (let i = 0; i < x.length; i++) {
          this.note = this.note.concat(x[i].note_1);
          x[i].note_1 = x[i].note_1.substring(0, 50) + '...';
        }
      }else{
        this.getAll();
      }
      this.apps = x;
      this.isLoading = false;
    });
  }
  getAll(){
    this.isLoading = true;
    this.service.getAll().subscribe( (x:any)=>{
      x = x.filter(x => x.id == this.event_id);
      console.log(x)
      if (x[0].reg_event_status == 1) {
        this.status = "Saved"

      }
      if (x[0].reg_event_status == 11) {
        this.status = "Ready for Approval"

      }
      if (x[0].reg_event_status == 13) {
        this.status = "Returned for editing"

      }
      if (x[0].reg_event_status == 15) {
        this.status = "Submitted for Approved"

      }
      if (x[0].reg_event_status == 21) {
        this.status = "Approved"

      }
      if (x[0].reg_event_status == 23) {
        this.status = "Submitted for Quote"

      }
      if (x[0].reg_event_status == 31) {
        this.status = "Quote Accepted"

      }
      this.selectedStatus = x[0].reg_event_status;
      this.date_scheduled = new DatePipe('en-US').transform(x[0].date_scheduled, 'yyyy-MM-dd');
      this.date_sent = new DatePipe('en-US').transform(x[0].date_sent, 'yyyy-MM-dd');
       this.isLoading = false;
    })
  }
  processAdvert() {
    this.isLoading = true;
    this.service.createAdvert(this.event_id).subscribe((data: string) => {
      this.isLoading = false;
       this.checkAdvert();
      if (!data.includes('File exsits')) {
        this.toastService.success(data, 'Advert');
      }
      if (data.includes('File exsits')) {
        this.toastService.error(data, 'Advert');
      }
    }, err => {
      this.isLoading = false;
      this.toastService.error(err, 'Advert');
    });
  }
  clickEdit() {
    this.isEdit = true;
  }
  clickBack() {
    this.isEdit = false;
  }
  saveModified() {
    this.isLoading = true;

    let name = this.authentication.userData.User.FirstName + ' ' + this.authentication.userData.User.LastName;
    let body = {
      note_1: this.note,
      reg_event_id: this.event_id,
      name: name,
      date_scheduled: this.date_scheduled,
      date_sent: this.date_sent,
      status: this.selectedStatus
    }

    this.service.modifyAdvert(body).subscribe(x => {
      this.isEdit = false;
      this.isLoading = false;
      if (x == true) {
        this.getApps(this.event_id);
        this.toastService.success('Modify successfully!', 'Advert');
      }
    })
  }
  saveModifiedGazette() {
    this.isLoading = true;

    let name = this.authentication.userData.User.FirstName + ' ' + this.authentication.userData.User.LastName;
    let body = {
      note_1: this.note,
      reg_event_id: this.event_id,
      name: name,
      date_scheduled: this.date_scheduled,
      date_sent: this.date_sent,
      status: this.selectedStatus
    }

    this.service.modifyGazette(body).subscribe(x => {
      // this.isEdit = false;
      this.isLoading = false;
      if (x == true) {
        this.getApps(this.event_id);
        // this.toastService.success('Modify successfully!', 'Advert');
      }
    })
  }
  delete(id){
    this.confirmDialogService.confirmThis(
      'Are you sure you want to delete this from the list?',
      () => {
          this.service.deleteRegulatoryApp(id).subscribe(data =>{
            this.toastService.success('Deteled successfully...','Gazette');
            this.getApps(this.event_id);
          })
      },
      () => {
          //No here
      }
  );
  }
  downloadFile() {
    this.service.downloadWord('Gazette - '+this.event_id).subscribe(x =>{
      const url= window.URL.createObjectURL(x);
     window.open(url,'_blank');
    })
   
  }
checkAdvert(){
  let body = {
    fileName:'Gazette - '+this.event_id+'.docx'
  }
  this.service.checkGazette(body).subscribe((x:boolean) =>{
    this.isAdvert = x;console.log(x)
  })
}
}
